/* ERGONOZ cart import — merges cart lines carried from ergonoz.com via
 * ?egn_cart=variantId:qty,variantId:qty into the native Shopify cart.
 * Idempotent: reads current cart and only adds the missing quantity per variant,
 * so revisiting a decorated link never duplicates lines. */
(function () {
  'use strict';
  var m = /[?&]egn_cart=([^&#]*)/.exec(location.search);
  if (!m) return;

  var items = [];
  decodeURIComponent(m[1]).split(',').forEach(function (p) {
    var kv = p.split(':');
    var id = parseInt(kv[0], 10);
    var q = parseInt(kv[1], 10) || 1;
    if (id > 0) items.push({ id: id, quantity: q });
  });

  function cleanUrl() {
    try {
      var u = new URL(location.href);
      u.searchParams.delete('egn_cart');
      history.replaceState(null, '', u.pathname + u.search + u.hash);
    } catch (e) {}
  }

  if (!items.length) { cleanUrl(); return; }

  fetch('/cart.js')
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var have = {};
      (cart.items || []).forEach(function (it) {
        have[it.variant_id] = (have[it.variant_id] || 0) + it.quantity;
      });
      var add = [];
      items.forEach(function (it) {
        var need = it.quantity - (have[it.id] || 0);
        if (need > 0) add.push({ id: it.id, quantity: need });
      });
      if (!add.length) { cleanUrl(); return; }
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: add })
      }).then(function (r) {
        cleanUrl();
        if (r && r.ok) location.reload();
      });
    })
    .catch(cleanUrl);
})();
